import { Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-form-template-fields',
  templateUrl: './form-template-fields.component.html',
  styleUrls: ['./form-template-fields.component.scss']
})
export class FormTemplateFieldsComponent implements OnInit {

  @Input() data: any = {};
  formTemplateFieldList: any = [];
  formTemplateFieldData: any = {};
  displayMsg = false;
  dangerMsg = false;
  resultMsg = "";
  isProcessing = false;
  searchValue = "";
  parentCheckBox: boolean = false;
  visibleAddButton = false;
  visibleEditButton = false;
  title: any;
  dropDownForDataType: any = [];
  dropDownForFieldType: any = [];
  dropDownForAutofillType: any = [];
  dropDownForAutofillFormula: any = [];
  dropDownForDateFormat: any = [];
  dropDownForMappingColumn: any = [];
  visibleReasonForUpdateField = false;

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  oddFieldType: any = null;
  oddFieldDataType: any = null;
  oddFieldDateFormat: any = null;
  oddMappingColumn: any = null;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;


  addAndEditPopupConfig = {
    width: '80%',
    minHeight: '50vh',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) {

  }
  //isProcessing:boolean=false;
  PageName: any;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  error = '';
  makeStickyColumns: any;
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  popupTitle: any;
  dateLovValuesDropdown: any = [];

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.formTemplateFieldList.length, page, this.perPage, targetPage);
    this.pagedItems = this.formTemplateFieldList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const element of this.formTemplateFieldList) {
        element.childCheckBox = true;
      }
    } else {
      for (const element of this.formTemplateFieldList) {
        element.childCheckBox = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
    } else {
      list.childCheckBox = false;
    }
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {

  }

  mappingColumnsList: any = [];
  mappingColumnsearchTxt: any;
  dateFormatsearchTxt: any
  mappingColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        const mappingColumn = this.formTemplateFieldList?.find((x: any) => x.MAPPING_COLUMN == event.valueExp);
        if (mappingColumn && ((this.visibleEditButton && mappingColumn.FIELD_ID != this.formTemplateFieldData.fieldId) ||
          this.visibleAddButton)) {

          const errorMsg = "Mapping column " + event.valueExp + " is used more than once in the form/log setup.";
          this.showSnackBar(errorMsg, 'E');
        }
      }
    }
  }

  getCall() {
    this.isProcessing = true;
    this.designationCodeValue = null;
    this.departmentCodeValue = null;
    this.statusCodeValue = null;
    this.formTemplateFieldList = [];

    const data = {

      gridName: "FORM_SECTION_TEMPLATE_FIELDS"
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        if (response.orderByClause == null) {
          response.orderByClause = "";
        }

        this.makeStickyColumns = response.fixedFieldCnt;

        let data1: any = {

          gridName: "ONEQMS_FORM_SECTION_TEMPLATE_FIELDS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: this.statusCodeValue,
          templateIdFromQmsReportTemplate: this.data.templateId,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        };

        if (this.data.isFrom == "Section") {
          data1.sectionId = this.data.sectionId;
        } else {
          data1.sectionId = 0;
        }

        this.reportObj = { ...data1, ...data };

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.formTemplateFieldList = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              });
            }

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };

            this.columnLists.columnsListarray1 = [];

            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;

                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;

                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }

                for (const field of this.formTemplateFieldList) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType === "CHECKBOX") {
                      field[dataType.columnName] = field[dataType.columnName] === "Y";
                    }
                  }
                }

                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
                this.dynamicLabelCall();
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });

            this.message.gridList = this.formTemplateFieldList;
            this.collectionSize = this.formTemplateFieldList.length;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });

        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  label: any = [];
  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.formTemplateFieldList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.formTemplateFieldList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  selectedFieldDatatype: any = null;
  selectedFieldType: any = null;
  selectedAutofillType: any = null;
  selectedAutofillFormula: any = null;
  selectedAutofillFormulaDetail: any = null;
  selectedFieldDateFormat: any = null;
  selectedMappingColumn: any = null;
  fieldDatattypeDropdown: any = [];
  fieldAutofillTypeDropdown: any = [];
  fieldAutofillFormulaDropdown: any = [];
  fieldTypeDropdown: any = [];
  fieldDateFormatDropdown: any = [];
  mappingColumnDropDown: any = [];
  ngOnInit(): void {
    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_DATATYPE").subscribe((data: any) => {
      this.dropDownForDataType = data;
      for (const element of this.dropDownForDataType) {
        this.fieldDatattypeDropdown = this.fieldDatattypeDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
    })
    this.appService.getNonOrgCodeListsByGroupName("DATE_LOV_VALUE").subscribe((data: any) => {
      for (const element of data) {
        this.dateLovValuesDropdown = this.dateLovValuesDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
    })
    this.appService.getNonOrgCodeListsByGroupName("FORMSANDLOGS_FIELDTYPE").subscribe((data: any) => {
      this.dropDownForFieldType = data;
      for (const element of this.dropDownForFieldType) {
        this.fieldTypeDropdown = this.fieldTypeDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
    })
    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_DATEFORMAT").subscribe((data: any) => {
      this.dropDownForDateFormat = data;

    })

    this.appService.getNonOrgCodeListsByGroupName("AUTOFILL_TYPE").subscribe((data: any) => {
      this.dropDownForAutofillType = data;
      for (const element of this.dropDownForAutofillType) {
        this.fieldAutofillTypeDropdown = this.fieldAutofillTypeDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
    })

    this.appService.getNonOrgCodeListsByGroupName("AUTOFILL_FORMAT").subscribe((data: any) => {
      this.dropDownForAutofillFormula = data;
      for (const element of this.dropDownForAutofillFormula) {
        this.fieldAutofillFormulaDropdown = this.fieldAutofillFormulaDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
    })
  }

  ngOnChanges() {
    this.getCall();
  }

  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }


  /*   onFieldTypeSelect(item: any) {
      if (item.valueExp == "Document Repository") {
        for (let i = 0; i < this.fieldDatattypeDropdown.length; i++) {
          if (this.fieldDatattypeDropdown[i].valueExp == "Char") {
            this.selectedFieldDatatype = [{
              valueExp: this.fieldDatattypeDropdown[i].valueExp,
              displayExp: this.fieldDatattypeDropdown[i].displayExp
            }]
            this.onSelectType(this.selectedFieldDatatype);
          }
        }

      } else {

      }
    } */

  fieldtypesearchTxt: any;

  onFieldTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item.valueExp != 'Text Field' && (this.selectedFieldDatatype == 'Date' || this.selectedFieldDatatype == 'Datetime')) { this.selectedFieldDatatype = null; } else {
        if (event.source._selected) {
          if (item) {
            if (item.valueExp == "Document Repository") {
              for (let i = 0; i < this.fieldDatattypeDropdown.length; i++) {
                if (this.fieldDatattypeDropdown[i].valueExp == "Char") {
                  /*                 this.selectedFieldDatatype = [{
                                    valueExp: this.fieldDatattypeDropdown[i].valueExp,
                                    displayExp: this.fieldDatattypeDropdown[i].displayExp
                                  }] */
                  this.selectedFieldDatatype = this.fieldDatattypeDropdown[i].valueExp;
                  this.onSelectType(this.event, this.selectedFieldDatatype);
                }
              }
              this.selectedAutofillType = null;
            } else if (item.valueExp == "Auto Generated Number") {
              for (let i = 0; i < this.fieldDatattypeDropdown.length; i++) {
                if (this.fieldDatattypeDropdown[i].valueExp == "Char") {
                  /*                 this.selectedFieldDatatype = [{
                                    valueExp: this.fieldDatattypeDropdown[i].valueExp,
                                    displayExp: this.fieldDatattypeDropdown[i].displayExp
                                  }] */
                  this.formTemplateFieldData.isEditable1 = false;
                  this.formTemplateFieldData.isMandatory1 = true;
                  this.selectedFieldDatatype = this.fieldDatattypeDropdown[i].valueExp;

                  this.onSelectType(this.event, this.selectedFieldDatatype);
                }
              }
              this.selectedAutofillType = null;
            } else if (item.valueExp == "Auto Fill") {
              for (let i = 0; i < this.fieldDatattypeDropdown.length; i++) {
                if (this.fieldDatattypeDropdown[i].valueExp == "Char") {
                  this.formTemplateFieldData.isEditable1 = true;
                  this.formTemplateFieldData.isPartOfUniqueness1 = false;
                  this.selectedFieldDatatype = this.fieldDatattypeDropdown[i].valueExp;
                  this.onSelectType(this.event, this.selectedFieldDatatype);
                }
              }
            } else {
              this.formTemplateFieldData.numberFormat = "";
              this.formTemplateFieldData.regenerationNumberFormat = "";
              this.formTemplateFieldData.noOfDigits = null;
            }
            this.selectedAutofillType = null;
            this.selectedAutofillFormula = null;
          }
        }
        this.selectedMappingColumn = null;
      }


    }

    // Auto-select 'Char' data type when Document Repository is selected
    if (this.selectedFieldType === 'Document Repository') {
      this.selectedFieldDatatype = 'Char';
      this.onSelectType(null, 'Char');
    }
  }
  @ViewChild('autofillTypeSelectRef') autofillTypeSelectRef: any;

  onAutofillTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          if (this.data.isFrom == "Section") {
            this.selectedAutofillType = item.valueExp;
          } else {
            if (item.valueExp == 'SUBMIT FOR VERIFICATION') {
              alert("'SUBMIT FOR VERIFICATION' shall not be applicable for Form Fields");
              setTimeout(() => {
                this.selectedAutofillType = null;
                this.formTemplateFieldData.autofillType = null;
                const autofillTypeField = document.getElementById('autofillType') as HTMLInputElement;
                if (autofillTypeField) {
                  autofillTypeField.style.color = '#005c8a';
                }
              }, 0);
              return;
            } else {
              this.selectedAutofillType = item.valueExp;
            }
          }
        }
      } else {
        this.selectedAutofillType = null;
      }
    }
  }
  onAutofillFormulaSelect(event: any, item: any, val: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedAutofillFormula = item.valueExp;
          this.selectedAutofillFormulaDetail = val;
          console.log("item.displayExp=", item);
          console.log("item.displayExp=", val);
          if (val == 'DD-MMM-YYYY' || val == 'MMM-DD-YYYY' || val == 'YYYY-MMM-DD') {
            console.log("item.displayExp=", val);
            for (let i = 0; i < this.fieldDatattypeDropdown.length; i++) {
              if (this.fieldDatattypeDropdown[i].valueExp == "Date") {
                this.selectedFieldDatatype = this.fieldDatattypeDropdown[i].valueExp;
                this.onSelectType(this.event, this.selectedFieldDatatype);
              }
            }
          } else if (val == 'DD-MMM-YYYY HH24:MI:SS' || val == 'DD-MMM-YYYY  HH24:MI:SS') {
            console.log("item.displayExp=", val);
            for (let i = 0; i < this.fieldDatattypeDropdown.length; i++) {
              if (this.fieldDatattypeDropdown[i].valueExp == "Datetime") {
                this.selectedFieldDatatype = this.fieldDatattypeDropdown[i].valueExp;
                this.onSelectType(this.event, this.selectedFieldDatatype);
              }
            }
          } else {
            for (let i = 0; i < this.fieldDatattypeDropdown.length; i++) {
              if (this.fieldDatattypeDropdown[i].valueExp == "Char") {
                this.selectedFieldDatatype = this.fieldDatattypeDropdown[i].valueExp;
                this.onSelectType(this.event, this.selectedFieldDatatype);
              }
            }
          }
        }
      } else {
        this.selectedAutofillFormula = null;
        this.selectedAutofillFormulaDetail = null;
      }
    }
  }
  isActiveToggerBoxValue: boolean;
  isActiverFunction(isTagged: boolean) {
    this.isActiveToggerBoxValue = isTagged;
  }

  onFieldFocusout(e: any) {

    this.formTemplateFieldData.question = this.formTemplateFieldData.fieldName;

  }

  refreshGridData() {
    this.getCall();
  }

  selectedLovValue: any;
  selectedDays: any;
  openAddPopup() {
    this.title = "Create Form " + this.data.isFrom + " Field";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.formTemplateFieldData = {};
    this.formTemplateFieldData.fieldName = "";
    this.formTemplateFieldData.question = "";
    this.formTemplateFieldData.instructions = "";
    this.formTemplateFieldData.fieldType = "";
    this.selectedFieldType = null;
    this.formTemplateFieldData.fieldDatatype = "";
    this.selectedFieldDatatype = null;
    this.formTemplateFieldData.fieldDateFormat = "";
    this.selectedFieldDateFormat = null;
    this.formTemplateFieldData.fieldWidth = "";
    this.formTemplateFieldData.fieldHeight = "";
    this.formTemplateFieldData.fieldDefaultValue = "";
    this.formTemplateFieldData.fieldDefaultValue = "";
    this.formTemplateFieldData.fieldLovValues = "";
    this.formTemplateFieldData.fieldLovQuery = "";
    this.formTemplateFieldData.mappingColumn = "";
    this.selectedMappingColumn = null;
    this.formTemplateFieldData.isEditable1 = true;
    this.formTemplateFieldData.isMandatory1 = false;
    this.formTemplateFieldData.isPartOfUniqueness1 = false;
    this.formTemplateFieldData.isActive1 = true;
    this.formTemplateFieldData.orderSeq = "";
    this.formTemplateFieldData.orderAscDesc = "";
    this.formTemplateFieldData.numberFormat = null;
    this.formTemplateFieldData.regenerationNumberFormat = null;
    this.formTemplateFieldData.noOfDigits = "";
    this.showDateFormatField = false;
    this.formTemplateFieldData.autofillType = null;
    this.formTemplateFieldData.autofillFormula = null;
    this.selectedAutofillFormula = null;
    this.selectedAutofillFormulaDetail = null;
    this.selectedAutofillType = null;
    this.mappingColumnsList = [];
    this.selectedLovValue = null;
    this.selectedDays = null;
    for (const element of this.formTemplateFieldList) {
      this.mappingColumnsList.push(element.MAPPING_COLUMN);
    }
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }
  subgroupArrayValue: any;
  openEditPopup(field1: any) {
    this.title = "Update Form " + this.data.isFrom + " Field";
    let field: any = {};
    this.selectedFieldDateFormat = null;
    this.selectedFieldType = null;
    this.selectedFieldDatatype = null;
    this.selectedLovValue = null;
    this.isProcessing = true;
    this.appService.getFormTemplateFieldByFieldId(field1.FIELD_ID).subscribe((data: any) => {
      field = data[0];
      this.isProcessing = false;

      field.isMandatory1 = field.isMandatory == "Y";
      field.isActive1 = field.isActive == "Y";
      field.isEditable1 = field.isEditable == "Y";
      field.isPartOfUniqueness1 = field.isPartOfUniqueness == "Y";
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.formTemplateFieldData = field;

      if (field.fieldDatatype) {
        this.callColumnFunc(field.fieldDatatype);
        if (field.fieldDatatype == 'Date' || field.fieldDatatype == 'Datetime') {
          this.showDateFormatField = true;
          if (this.formTemplateFieldData.fieldLovValues != null) {
            this.selectedLovValue = this.formTemplateFieldData.fieldLovValues;
            if (this.formTemplateFieldData.fieldLovValues.includes("+")) {
              let data = this.formTemplateFieldData.fieldLovValues.split("+");
              this.selectedDays = parseInt(data[1]);
              data[1] = "n";
              this.selectedLovValue = data.join("+ ");
            } else
              if (this.formTemplateFieldData.fieldLovValues.includes("-")) {
                let data = this.formTemplateFieldData.fieldLovValues.split("-");
                this.selectedDays = parseInt(data[1]);
                data[1] = "n";
                this.selectedLovValue = data.join("- ");
              }
          }
        } else {
          this.showDateFormatField = false;
          this.selectedFieldDateFormat = null;
          this.formTemplateFieldData.dateFormat = null;
        }
      }

      if (field.fieldType) {
        const matchingFieldType = this.dropDownForFieldType?.find((item: any) => item.codelistCode == field.fieldType);
        if (!matchingFieldType) {
          this.oddFieldType = field.fieldType;
          this.fieldTypeDropdown.push({
            valueExp: field.fieldType,
            displayExp: field.fieldType
          })
        }
        this.selectedFieldType = field.fieldType
      }
      this.mappingColumnsList = [];
      for (const element of this.formTemplateFieldList) {
        if (field.fieldId != element.FIELD_ID) {
          this.mappingColumnsList.push(element.MAPPING_COLUMN);
        }
      }

      if (field.fieldDatatype) {
        const matchingFieldDataType = this.dropDownForDataType?.find((item: any) => item.codelistCode == field.fieldDatatype);
        if (!matchingFieldDataType) {
          this.oddFieldDataType = field.fieldDatatype;
          this.fieldDatattypeDropdown.push({
            valueExp: field.fieldDatatype,
            displayExp: field.fieldDatatype
          })
        }
        this.selectedFieldDatatype = field.fieldDatatype
      }

      if (field.fieldDateFormat) {
        const matchingFieldDateFormat = this.dropDownForDateFormat?.find((item: any) => item.codelistCode == field.fieldDateFormat);
        if (!matchingFieldDateFormat) {
          this.oddFieldDateFormat = field.fieldDateFormat;
          this.fieldDateFormatDropdown.push({
            valueExp: field.fieldDateFormat,
            displayExp: field.fieldDateFormat
          })
        }
        this.selectedFieldDateFormat = field.fieldDateFormat
      }
      if (field.autofillType) {

        this.selectedAutofillType = field.autofillType
      }

      if (field.autofillFormula) {

        this.selectedAutofillFormula = field.autofillFormula;
        this.selectedAutofillFormulaDetail = field.autofillFormulaDetail
      }
      this.formTemplateFieldData.updateReason = '';
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    })

  }

  validateLovValues(event: any): boolean {
    if (this.selectedFieldDatatype == 'Number') {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 44 && charCode != 46) {
        return false;
      }
      return true;
    }
    return true;
  }

  deleteReason: any = null;
  openDeletePopup(field1: any) {
    this.deleteReason = null;
    this.title = "Delete Form " + this.data.isFrom + " Field";
    this.isProcessing = true;
    this.appService.getFormTemplateFieldByFieldId(field1.FIELD_ID).subscribe((data: any) => {
      this.formTemplateFieldData = data[0];
      this.isProcessing = false;
      this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
    });
  }

  callColumnFunc(dataType: any) {
    this.isProcessing = true;
    let dataTye = dataType;
    if (dataType == "Char") {
      dataTye = "VARCHAR2";
    } else if (dataType == "Number") {
      dataTye = "NUMBER";
    } else if (dataType == "Date" || dataType == "Datetime") {
      dataTye = "DATE";
    }
    this.mappingColumnDropDown = [];
    this.appService.getDataTypeForMappingColumnForForm(dataTye).subscribe((data: any) => {
      this.dropDownForMappingColumn = data;
      this.isProcessing = false;
      for (const element of this.dropDownForMappingColumn) {
        this.mappingColumnDropDown = this.mappingColumnDropDown.concat({
          valueExp: element,
          displayExp: element
        });
      }
      for (const element of this.mappingColumnDropDown) {
        if (element.valueExp == this.formTemplateFieldData.mappingColumn) {
          this.selectedMappingColumn = element.valueExp;
        }
      }
    })
  }


  onDeleteReasonFocusout(e: any) {
    this.deleteReasonValidation();
  }

  deleteReasonValidation() {
    const deleteReason = document.getElementById('deleteReason') as HTMLInputElement;
    const deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.deleteReason == "" || this.deleteReason == null || this.deleteReason == undefined) {
      deleteReason.style.border = '1px solid red';
      deleteReasonRequiredMsg.style.display = 'block';
    } else {
      deleteReason.style.border = 'none';
      deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  showDateFormatField = false;
  /*   onSelectType(event: any) {
      this.callColumnFunc(this.selectedFieldDatatype[0].valueExp);
      if (this.selectedFieldDatatype[0].valueExp == 'Date') {
        this.showDateFormatField = true;
      } else {
        this.showDateFormatField = false;
        this.selectedFieldDateFormat = [];
        this.formTemplateFieldData.dateFormat = null;
      }
    } */

  dataTypesearchTxt: any;
  autofillTypesearchTxt: any;
  autofillFormulasearchTxt: any;
  onSelectType(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedMappingColumn = null;
      if (event.source._selected) {
        this.callColumnFunc(item);
        if ((item == 'Date' || item == 'Datetime') && (this.selectedFieldType != 'Text Field' && this.selectedFieldType != 'Auto Fill')) {

          this.selectedFieldType = 'Text Field';
          // alert("Field Type is non 'Text Field' so must select Text Field");
        } else {
          if (item == 'Date') {
            this.showDateFormatField = true;
            this.fieldDateFormatDropdown = [];
            this.fieldDateFormatDropdown = this.fieldDateFormatDropdown.concat({
              valueExp: this.dropDownForDateFormat[0].codelistCode,
              displayExp: this.dropDownForDateFormat[0].codelistName
            });

          } else if (item == 'Datetime') {
            this.showDateFormatField = true;
            this.fieldDateFormatDropdown = [];
            this.fieldDateFormatDropdown = this.fieldDateFormatDropdown.concat({
              valueExp: this.dropDownForDateFormat[1].codelistCode,
              displayExp: this.dropDownForDateFormat[1].codelistName
            });

          } else {
            this.showDateFormatField = false;
            this.selectedFieldDateFormat = null;
            this.formTemplateFieldData.dateFormat = null;
          }
          this.formTemplateFieldData.dateFormat = null;
        }

      }
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: !this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.secondLevel
          : this.message.breadcrumbData.thirdLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'business-area-validation' || fieldId === 'root-cause-type-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  pushedAllowedBusinessAreas: any = [];
  addAndEditFunction(fieldData: any) {
    this.isProcessing = true;

    const validations = [
      { condition: !fieldData.fieldName, id: 'fieldName' },
      { condition: !this.selectedFieldType, id: 'fieldType' },
      { condition: !this.selectedFieldDatatype, id: 'dataType' },
      { condition: !fieldData.question, id: 'question' },
      { condition: !this.selectedMappingColumn, id: 'mappingCol' },
      { condition: this.selectedFieldType == "Auto Generated Number" && !fieldData.numberFormat, id: 'numberFormat' },
      { condition: this.selectedFieldType == "Auto Generated Number" && !fieldData.noOfDigits, id: 'noOfDigits' },
      { condition: this.selectedFieldType == "Auto Fill" && !this.selectedAutofillType, id: 'autofillType' },
      { condition: this.selectedFieldType == "Auto Fill" && !this.selectedAutofillFormula, id: 'autofillFormula' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.isProcessing = false;
      this.fieldValidation(invalidIds);
    } else if (fieldData.fieldName && fieldData.fieldName.includes(',')) {
      this.isProcessing = false;
      alert("Comma is not allowed in field name!");
      return;
    } else if (fieldData['fieldId'] == undefined) {
      const mappingColumn = this.formTemplateFieldList?.find((x: any) => x.MAPPING_COLUMN == this.selectedMappingColumn);
      if (mappingColumn) {
        this.isProcessing = false;
        const errorMsg = "Mapping column " + this.selectedMappingColumn + " is used more than once in the form/log setup.";
        this.showSnackBar(errorMsg, 'E');
      } else {
        this.create(fieldData);
      }
    } else {
      const mappingColumn = this.formTemplateFieldList?.find((x: any) => x.MAPPING_COLUMN == this.selectedMappingColumn);
      if (mappingColumn && mappingColumn.FIELD_ID != fieldData.fieldId) {
        this.isProcessing = false;
        const errorMsg = "Mapping column " + this.selectedMappingColumn + " is used more than once in the form/log setup.";
        this.showSnackBar(errorMsg, 'E');
      } else {
        this.update(fieldData);
      }
    }
  }

  create(fieldData: any) {

    fieldData['isMandatory'] = fieldData['isMandatory1'] ? "Y" : "N";
    fieldData['isActive'] = fieldData['isActive1'] ? "Y" : "N";
    fieldData['isEditable'] = fieldData['isEditable1'] ? "Y" : "N";
    fieldData['isPartOfUniqueness'] = fieldData['isPartOfUniqueness1'] ? "Y" : "N";
    fieldData['fieldType'] = this.selectedFieldType ?? null;
    fieldData['fieldDatatype'] = this.selectedFieldDatatype ?? null;
    fieldData['fieldDateFormat'] = this.selectedFieldDateFormat ?? null;
    fieldData['mappingColumn'] = this.selectedMappingColumn ?? null;
    fieldData['templateId'] = this.data.templateId;
    fieldData['autofillType'] = this.selectedAutofillType ?? null;
    fieldData['autofillFormula'] = this.selectedAutofillFormula ?? null;
    fieldData['autofillFormulaDetail'] = this.selectedAutofillFormulaDetail ?? null;
    if (this.data.isFrom == "Section") {
      fieldData['sectionId'] = this.data.sectionId;
    } else {
      fieldData['sectionId'] = 0;
    }

    this.appService.createFormTemplateField(fieldData).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  update(fieldData: any) {
    this.isProcessing = true;
    delete fieldData['createdOn'];
    delete fieldData['updatedOn'];
    fieldData['isMandatory'] = fieldData['isMandatory1'] ? "Y" : "N";
    fieldData['isActive'] = fieldData['isActive1'] ? "Y" : "N";
    fieldData['isEditable'] = fieldData['isEditable1'] ? "Y" : "N";
    fieldData['isPartOfUniqueness'] = fieldData['isPartOfUniqueness1'] ? "Y" : "N";

    fieldData['fieldType'] = this.selectedFieldType ?? null;
    fieldData['fieldDatatype'] = this.selectedFieldDatatype ?? null;
    fieldData['fieldDateFormat'] = this.selectedFieldDateFormat ?? null;
    fieldData['mappingColumn'] = this.selectedMappingColumn ?? null;
    fieldData['autofillType'] = this.selectedAutofillType ?? null;
    fieldData['autofillFormula'] = this.selectedAutofillFormula ?? null;
    fieldData['autofillFormulaDetail'] = this.selectedAutofillFormulaDetail ?? null;
    this.appService.updateFormTemplateField(fieldData).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  deleteFunction() {
    if (!this.deleteReason) {
      this.deleteReasonValidation();
    } else {
      this.isProcessing = true;

      const obj = {

        fieldId: this.formTemplateFieldData.fieldId,
        deleteReason: this.deleteReason,
        fieldName: this.formTemplateFieldData.fieldName
      }

      this.appService.deleteFormTemplateField(obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {}

  openAuditTrail(viewType: any, field: any) {
    this.auditTrail.form_TemplateId_Audit_Trail = this.data.templateId;
    this.auditTrail.form_SectionId_Audit_Trail = this.data.isFrom == "Section" ? this.data.sectionId : 0;
    this.auditTrail.refNo = viewType == 'overAll' ? null : field.FIELD_ID;
    this.auditTrail.gridName = 'FORM_SECTION_TEMPLATE_FIELDS';
    this.auditTrail.report_And_Popup_Name = 'Forms Section Fields Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(field);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Form Section Fields Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  setPagedorserch(page: number, targetpage: number) {
    if (isNaN(page)) {
      page = 1;
    }

    if (this.formTemplateFieldsListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.formTemplateFieldsListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.formTemplateFieldsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  lovValuesearchTxt: string = '';
  formTemplateFieldsListTemp: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.formTemplateFieldsListTemp = this.formTemplateFieldList;
      this.pager = this.paginationService.getPager(this.formTemplateFieldsListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.formTemplateFieldsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.formTemplateFieldList == undefined) {
        return this.formTemplateFieldList;
      }
      if (!this.formTemplateFieldList.length) {
        return this.formTemplateFieldList;
      }
      if (filter != undefined) {
        this.formTemplateFieldsListTemp = this.formTemplateFieldList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });


      } else {
        this.formTemplateFieldsListTemp = this.formTemplateFieldList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });

      }
      this.setPagedorserch(1, 0);
    }
  }

  onNumberOfDaysEntered(days: any) {
    if (this.selectedLovValue.includes("+")) {
      let data = this.selectedLovValue.split("+")
      data[1] = days;
      this.formTemplateFieldData.fieldLovValues = data.join("+ ");
    }
    if (this.selectedLovValue.includes("-")) {
      let data = this.selectedLovValue.split("-")
      data[1] = days;
      this.formTemplateFieldData.fieldLovValues = data.join("- ");
    }
  }

  lovValuesSelect(event: any, data: any) {
    if (event.isUserInput) {
      this.selectedDays = null;
      this.formTemplateFieldData.fieldLovValues = data;
    }

  }
  // REORDER PROPERTIES
  @ViewChild('reorderPopup', { static: true }) reorderPopup: TemplateRef<any>;
  visibleReorderPopup: MatDialogRef<TemplateRef<any>>;
  reorderList: any[] = [];
  isReordered: boolean = false;
  reorderTitle: string = 'Form Fields Reorder';

  reorderPopupConfig = {
    width: '900px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  // ... [Keep Constructor and other methods] ...

  // 1. OPEN REORDER POPUP
  openReorderPopup() {
    this.isReordered = false;
    // Deep copy to protect main grid data
    this.reorderList = JSON.parse(JSON.stringify(this.formTemplateFieldList));

    // Initialize NEW_ORDER based on FIELD_SEQ from your JSON
    this.reorderList.forEach((item, index) => {
      // Use FIELD_SEQ if it exists, otherwise fallback to array index + 1
      const currentSeq = item.FIELD_SEQ ? parseInt(item.FIELD_SEQ) : (index + 1);
      item.NEW_ORDER = currentSeq;
    });

    // Sort the list so it appears in the correct order (1, 2, 3) in the popup
    this.reorderList.sort((a, b) => a.NEW_ORDER - b.NEW_ORDER);

    this.visibleReorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }

  // 2. DRAG AND DROP LOGIC
  dragAndDrop(event: CdkDragDrop<string[]>) {
    // Move item visually in the array
    moveItemInArray(this.reorderList, event.previousIndex, event.currentIndex);

    // Re-calculate NEW_ORDER (1, 2, 3...) based on the new array position
    this.reorderList.forEach((item, index) => {
      item.NEW_ORDER = index + 1;
    });

    this.isReordered = true;
  }

  // 3. CANCEL
  cancelReorder() {
    this.visibleReorderPopup.close();
    this.reorderList = [];
  }

  // 4. SAVE REORDER (API CALL)
  saveReorder() {
    this.isProcessing = true;

    const updatePromises = this.reorderList.map(item => {

      const safeValue = (val: any) => (val !== undefined && val !== null) ? val : null;

      // Construct Payload based on your JSON structure
      const payload = {

        templateId: this.data.templateId,
        sectionId: this.data.isFrom == "Section" ? this.data.sectionId : 0,

        // --- IDENTITY & SEQUENCE ---
        fieldId: item.FIELD_ID,
        fieldName: item.FIELD_NAME,
        // UPDATE SEQUENCE: sending the calculated NEW_ORDER as fieldSeq
        fieldSeq: item.NEW_ORDER,

        // --- CORE FIELDS (Mapped from your JSON) ---
        fieldType: safeValue(item.FIELD_TYPE),
        fieldDatatype: safeValue(item.FIELD_DATATYPE),
        fieldDateFormat: safeValue(item.FIELD_DATE_FORMAT),
        mappingColumn: safeValue(item.MAPPING_COLUMN),

        // --- QUESTION & INSTRUCTIONS ---
        question: safeValue(item.QUESTION),
        instructions: safeValue(item.INSTRUCTIONS),

        // --- AUTOFILL & LOGIC ---
        autofillType: safeValue(item.AUTOFILL_TYPE),
        autofillFormula: safeValue(item.AUTOFILL_FORMULA),
        autofillFormulaDetail: safeValue(item.AUTOFILL_FORMULA_DETAIL),
        fieldDefaultValue: safeValue(item.FIELD_DEFAULT_VALUE),

        // --- LOV (List of Values) ---
        fieldLovValues: safeValue(item.FIELD_LOV_VALUES),
        fieldLovQuery: safeValue(item.FIELD_LOV_QUERY),

        // --- FORMATTING ---
        numberFormat: safeValue(item.NUMBER_FORMAT),
        regenerationNumberFormat: safeValue(item.REGENERATION_NUMBER_FORMAT),
        noOfDigits: safeValue(item.NO_OF_DIGITS),
        fieldWidth: safeValue(item.FIELD_WIDTH),
        fieldHeight: safeValue(item.FIELD_HEIGHT),

        // --- BOOLEAN FLAGS (Convert "Y"/"N" from JSON to "Y"/"N" for payload) ---
        // Your JSON has "Y"/"N", usually APIs expect "Y"/"N".
        // If your grid converts them to boolean true/false, use the ternary check.
        isMandatory: item.IS_MANDATORY === true || item.IS_MANDATORY === "Y" ? "Y" : "N",
        isActive: item.IS_ACTIVE === true || item.IS_ACTIVE === "Y" ? "Y" : "N",
        isEditable: item.IS_EDITABLE === true || item.IS_EDITABLE === "Y" ? "Y" : "N",
        isPartOfUniqueness: item.IS_PART_OF_UNIQUENESS === true || item.IS_PART_OF_UNIQUENESS === "Y" ? "Y" : "N",

        // --- REASON ---
        updateReason: "Reordered Field Sequence"
      };

      return this.appService.updateFormTemplateField(payload).toPromise();
    });

    Promise.all(updatePromises)
      .then(() => {
        this.isProcessing = false;
        this.visibleReorderPopup.close();
        this.showSnackBar("Fields reordered successfully", "S");
        this.getCall();
      })
      .catch((error) => {
        this.isProcessing = false;
        console.error("Reorder failed", error);
        this.showSnackBar("Failed to reorder fields", "E");
      });
  }
}
